export default __webpack_public_path__ + "static/media/rating_6.6a21da94.svg";